/**
 * Storage inventory behind the offline AI assistant's dependent form fields.
 *
 * The delete-volume form loads storage VMs for the chosen cluster and volumes for
 * the chosen storage VM, so all three dropdowns have to describe the same
 * topology. Mirage answers both lookups from the tables below, with a deliberate
 * delay so the dropdown's loading state is visible while the answer arrives.
 */

/** Clusters seeded as the form's first dropdown. */
const CLUSTERS = [
    { id: '6a308219-2f3c-11f1-b248-005056bd5941', name: 'C1_sti248-vsim-ocvs076k' },
    { id: 'b3c5c624-2c0e-11f1-b729-005056bdfe1b', name: 'AsaR2_916-c_cluster' }
];

const SVMS = [
    { id: '93aa579a-2f3d-11f1-b249-005056bd5941', name: 'vs0', clusterId: CLUSTERS[0].id },
    { id: '4f21c8ba-2f3d-11f1-b249-005056bd5941', name: 'vs_engineering', clusterId: CLUSTERS[0].id },
    { id: '06a7487c-2c0f-11f1-b729-005056bdfe1b', name: 'svm1', clusterId: CLUSTERS[1].id },
    { id: 'c8be1d34-2c0f-11f1-b729-005056bdfe1b', name: 'svm_backup', clusterId: CLUSTERS[1].id }
];

const VOLUMES = [
    { id: '92c08026-35d2-45fe-8c1b-67b08d0c0322', name: 'vol_finance_reports', svmId: SVMS[0].id },
    { id: 'a7f19b3e-42c6-4d1a-9f7e-8b2d3c4e5f6a', name: 'vol_hr_archive_2023', svmId: SVMS[0].id },
    { id: 'c1d2e3f4-a5b6-7c8d-9e0f-1a2b3c4d5e6f', name: 'vol_build_cache', svmId: SVMS[1].id },
    { id: 'd4e5f6a7-b8c9-0d1e-2f3a-4b5c6d7e8f9a', name: 'vol_ci_artifacts', svmId: SVMS[1].id },
    { id: 'e5f6a7b8-c9d0-1e2f-3a4b-5c6d7e8f9a0b', name: 'vol_legacy_backup', svmId: SVMS[2].id },
    { id: 'f6a7b8c9-d0e1-2f3a-4b5c-6d7e8f9a0b1c', name: 'vol_test_restore', svmId: SVMS[2].id },
    { id: '0b1c2d3e-4f5a-6b7c-8d9e-0f1a2b3c4d5e', name: 'vol_snapmirror_stale', svmId: SVMS[3].id }
];

/** Paths the form's `apiURL` templates point at, relative to the OCCM endpoint. */
export const SIMULATOR_SVM_LOOKUP_PATH = 'ai-simulator/v1/svms';
export const SIMULATOR_VOLUME_LOOKUP_PATH = 'ai-simulator/v1/volumes';

// Long enough for the dependent dropdown's spinner to register as a real lookup.
const LOOKUP_TIMING_MS = 900;

const toOptionItem = ({ id, name }) => ({ id, name });

export const listSimulatorClusters = () => CLUSTERS.map(toOptionItem);

export const listSimulatorSvms = (clusterId) => SVMS
    .filter((svm) => svm.clusterId === clusterId)
    .map(toOptionItem);

export const listSimulatorVolumes = (svmId) => VOLUMES
    .filter((volume) => volume.svmId === svmId)
    .map(toOptionItem);

/**
 * Registers the two lookups on the Mirage server.
 * @param {Object} route - The Mirage route object being configured.
 */
export const seedAiSimulatorAssetRoutes = (route) => {
    route.get(
        `/${SIMULATOR_SVM_LOOKUP_PATH}`,
        (_schema, req) => ({ items: listSimulatorSvms(req.queryParams?.clusterId) }),
        { timing: LOOKUP_TIMING_MS }
    );

    route.get(
        `/${SIMULATOR_VOLUME_LOOKUP_PATH}`,
        (_schema, req) => ({ items: listSimulatorVolumes(req.queryParams?.svmId) }),
        { timing: LOOKUP_TIMING_MS }
    );
};